<h1 mat-dialog-title>
  {{ title }}
</h1>
<form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput formControlName="name" />
        <mat-error [control]="addEditForm.get('name')"></mat-error>
      </mat-form-field>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ title }}
    </button>
  </mat-dialog-actions>
</form>
